'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Checkbox, Divider, Input, TextArea } from '@common/components';
import { useToast } from '@common/hooks';
import { SvgChevronleft } from '@common/icon';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { AuthApi } from '@/api';
import { Image } from '@/components/client';
import { closeResponsiveDialog } from '@/stores/DrawerStore';
const TITLE_MAX = 200;
const CONTENT_MAX = 3000;
const DEFAULT_INQUIRY_TYPE = 'LOCAL_MARKET_PRODUCT_INQUIRY_TYPE_PRODUCT';
interface InquiryModalContentProps {
  productId: string;
  productImageUrl?: string;
  vendorRegion?: string;
  vendorName?: string;
  productName?: string;
  onClose?: () => void;
}
export const InquiryModalContent = t0 => {
  const $ = _c(80);
  const {
    productId,
    productImageUrl,
    vendorRegion,
    vendorName,
    productName,
    onClose
  } = t0;
  const {
    toast
  } = useToast();
  const queryClient = useQueryClient();
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [isPrivate, setIsPrivate] = useState(false);
  let t1;
  if ($[0] !== content || $[1] !== title) {
    t1 = !title.trim() || !content.trim();
    $[0] = content;
    $[1] = title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const isSubmitDisabled = t1;
  let t2;
  if ($[3] !== content || $[4] !== isPrivate || $[5] !== productId || $[6] !== title) {
    t2 = async () => {
      await AuthApi["post:/wello/v2/auth/local-market/products/{productId}/inquiries"]({
        path: {
          productId
        },
        body: {
          title,
          inquiryTypeCode: DEFAULT_INQUIRY_TYPE,
          contents: content,
          secretYN: isPrivate
        }
      });
    };
    $[3] = content;
    $[4] = isPrivate;
    $[5] = productId;
    $[6] = title;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== productId || $[9] !== queryClient || $[10] !== toast) {
    t3 = () => {
      toast({
        message: "\uBB38\uC758\uAC00 \uB4F1\uB85D\uB418\uC5C8\uC2B5\uB2C8\uB2E4."
      });
      queryClient.invalidateQueries({
        queryKey: ["local-market-inquiries", productId]
      });
      closeResponsiveDialog();
    };
    $[8] = productId;
    $[9] = queryClient;
    $[10] = toast;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== toast) {
    t4 = () => {
      toast({
        message: "\uBB38\uC758 \uB4F1\uB85D\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4.",
        type: "fail"
      });
    };
    $[12] = toast;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== t2 || $[15] !== t3 || $[16] !== t4) {
    t5 = {
      mutationFn: t2,
      onSuccess: t3,
      onError: t4
    };
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  const {
    mutateAsync: submitInquiry,
    isPending: isSubmitting
  } = useMutation(t5);
  let t6;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <SvgChevronleft className="size-24 text-Gray-900" />;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== onClose) {
    t7 = <header className="hidden min-h-56 items-center px-20 mobile-tablet:flex"><button type="button" onClick={onClose} className="flex size-24 items-center justify-center" aria-label={"\uB4A4\uB85C\uAC00\uAE30"}>{t6}</button></header>;
    $[19] = onClose;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  const t8 = productImageUrl ?? "";
  const t9 = productName ?? "\uC0C1\uD488 \uC774\uBBF8\uC9C0";
  let t10;
  if ($[21] !== t8 || $[22] !== t9) {
    t10 = <Image src={t8} width={104} height={104} alt={t9} className="size-104 shrink-0 rounded-none border border-Gray-black/5 object-cover mobile-tablet:size-80" />;
    $[21] = t8;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== vendorRegion) {
    t11 = vendorRegion && <span className="rounded-none bg-Gray-200 px-6 py-3 font-600 text-Gray-600 typo-caption2">{vendorRegion}</span>;
    $[24] = vendorRegion;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== vendorName) {
    t12 = vendorName && <span className="font-600 text-Gray-600 typo-caption1">{vendorName}</span>;
    $[26] = vendorName;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t11 || $[29] !== t12) {
    t13 = <div className="flex items-center gap-8">{t11}{t12}</div>;
    $[28] = t11;
    $[29] = t12;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== productName) {
    t14 = productName && <p className="line-clamp-2 font-500 text-Gray-900 typo-body3 mobile-tablet:typo-body4">{productName}</p>;
    $[31] = productName;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t13 || $[34] !== t14) {
    t15 = <div className="flex flex-col gap-8 mobile-tablet:gap-4">{t13}{t14}</div>;
    $[33] = t13;
    $[34] = t14;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== t10 || $[37] !== t15) {
    t16 = <div className="flex items-center gap-20">{t10}{t15}</div>;
    $[36] = t10;
    $[37] = t15;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Divider className="hidden h-8 w-full bg-Gray-100 mobile-tablet:-mx-20 mobile-tablet:block mobile-tablet:w-[calc(100%+40px)]" />;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <span className="font-400 text-Gray-700 typo-body4">문의 제목</span>;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== title.length) {
    t19 = <div className="flex items-center gap-8">{t18}<span className="font-400 text-Gray-400 typo-caption1">{title.length}/{TITLE_MAX}</span></div>;
    $[41] = title.length;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = checked => setIsPrivate(checked);
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  let t21;
  if ($[44] !== isPrivate) {
    t21 = <Checkbox checked={isPrivate} onCheckedChange={t20} className="[&_button[data-state=checked]]:bg-O-400">비공개</Checkbox>;
    $[44] = isPrivate;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  if ($[46] !== t19 || $[47] !== t21) {
    t22 = <div className="flex items-center justify-between">{t19}{t21}</div>;
    $[46] = t19;
    $[47] = t21;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = e => setTitle(e.target.value);
    $[49] = t23;
  } else {
    t23 = $[49];
  }
  let t24;
  if ($[50] !== title) {
    t24 = <Input placeholder={"\uBB38\uC758 \uC81C\uBAA9\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694."} dimensions="H48" value={title} maxLength={TITLE_MAX} onChange={t23} className="!rounded-none" />;
    $[50] = title;
    $[51] = t24;
  } else {
    t24 = $[51];
  }
  let t25;
  if ($[52] !== t22 || $[53] !== t24) {
    t25 = <div className="flex flex-col gap-4">{t22}{t24}</div>;
    $[52] = t22;
    $[53] = t24;
    $[54] = t25;
  } else {
    t25 = $[54];
  }
  let t26;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <span className="font-400 text-Gray-700 typo-body4">문의 내용</span>;
    $[55] = t26;
  } else {
    t26 = $[55];
  }
  let t27;
  if ($[56] !== content.length) {
    t27 = <div className="flex items-center justify-between">{t26}<span className="font-400 text-Gray-400 typo-caption1">{content.length}/{CONTENT_MAX}</span></div>;
    $[56] = content.length;
    $[57] = t27;
  } else {
    t27 = $[57];
  }
  let t28;
  if ($[58] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = e_0 => setContent(e_0.target.value);
    $[58] = t28;
  } else {
    t28 = $[58];
  }
  let t29;
  if ($[59] !== content) {
    t29 = <TextArea placeholder={"\uBB38\uC758 \uB0B4\uC6A9\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694."} value={content} maxLength={CONTENT_MAX} onChange={t28} autoResize={false} className="h-160 w-full !rounded-none border-Gray-300" />;
    $[59] = content;
    $[60] = t29;
  } else {
    t29 = $[60];
  }
  let t30;
  if ($[61] !== t27 || $[62] !== t29) {
    t30 = <div className="flex flex-col gap-4">{t27}{t29}</div>;
    $[61] = t27;
    $[62] = t29;
    $[63] = t30;
  } else {
    t30 = $[63];
  }
  let t31;
  if ($[64] !== t25 || $[65] !== t30) {
    t31 = <div className="flex flex-col gap-24">{t25}{t30}</div>;
    $[64] = t25;
    $[65] = t30;
    $[66] = t31;
  } else {
    t31 = $[66];
  }
  let t32;
  if ($[67] !== t16 || $[68] !== t31) {
    t32 = <div className="flex-1 overflow-auto mobile-tablet:px-20"><div className="flex flex-col gap-24">{t16}{t17}{t31}</div></div>;
    $[67] = t16;
    $[68] = t31;
    $[69] = t32;
  } else {
    t32 = $[69];
  }
  const t33 = isSubmitDisabled || isSubmitting;
  let t34;
  if ($[70] !== submitInquiry) {
    t34 = () => submitInquiry();
    $[70] = submitInquiry;
    $[71] = t34;
  } else {
    t34 = $[71];
  }
  const t35 = isSubmitting ? "\uB4F1\uB85D \uC911..." : "\uB4F1\uB85D";
  let t36;
  if ($[72] !== t33 || $[73] !== t34 || $[74] !== t35) {
    t36 = <footer className="shrink-0 pb-20 pt-12 mobile-tablet:px-20 mobile-tablet:pb-32 mobile-tablet:shadow-[6px_-6px_20px_0px_rgba(0,0,0,0.04),0px_20px_20px_0px_rgba(0,0,0,0.04),0px_4px_4px_0px_rgba(0,0,0,0.06)]"><Button theme="primary-fill" dimensions="H56" className="w-full !rounded-none border-none bg-O-400 font-700 typo-body1 hover:bg-O-300 hover:outline-none focus:outline-none disabled:bg-Gray-200" disabled={t33} onClick={t34}>{t35}</Button></footer>;
    $[72] = t33;
    $[73] = t34;
    $[74] = t35;
    $[75] = t36;
  } else {
    t36 = $[75];
  }
  let t37;
  if ($[76] !== t32 || $[77] !== t36 || $[78] !== t7) {
    t37 = <div className="flex h-full flex-col">{t7}{t32}{t36}</div>;
    $[76] = t32;
    $[77] = t36;
    $[78] = t7;
    $[79] = t37;
  } else {
    t37 = $[79];
  }
  return t37;
};